<div class="modal" id="vehicleDeviceSet" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="btn-close" (click)="dialogClose()"></button>
			</div>
			<div class="modal-body">
				<label for="device">Urządzenie</label>
				<ng-select
					id="device"
					placeholder="(wybierz)"
					name="device"
					[multiple]="false"
					[(ngModel)]="data.device"
				>
					<ng-option value="">(wybierz)</ng-option>
					<ng-option [value]="item.clientObject" *ngFor="let item of deviceList">
						{{ item.clientObject }} {{ item.objectName }}
					</ng-option>
				</ng-select>
				<div class="form-floating mb-3">
					<input
						type="date"
						class="form-control"
						name="dateFrom"
						id="dateFrom"
						[(ngModel)]="data.dateFrom"
						[readonly]="isItemBefore"
					/>
					<label for="dateFrom">Data od</label>
				</div>
				<div class="form-floating mb-3">
					<input
						type="date"
						class="form-control"
						name="dateTo"
						id="dateTo"
						[(ngModel)]="data.dateTo"
						[readonly]="isItemAfter"
					/>
					<label for="dateTo">Data do</label>
				</div>
			</div>
			<div class="modal-footer">
				<div class="container">
					<div class="row">
						<div class="col-sm">
							<button class="btn btn-danger" (click)="deleteOpen()">
								<i class="far fa-trash-alt"></i> Usuń
							</button>
						</div>
						<div class="col-sm text-end">
							<button type="button" class="btn btn-primary me-4" (click)="submit()">Zapisz</button>
							<button
								type="button"
								class="btn btn-secondary"
								data-bs-dismiss="modal"
								(click)="dialogClose()"
							>
								Anuluj
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<app-dynamic-table
	[elements]="vehicleDevice"
	[tableRows]="tableRows"
	[haveLink]="false"
	[haveButton]="true"
	[haveAnyFilters]="false"
	(buttonClicked)="selectOwner($event)"
></app-dynamic-table>
